import { careerOptions } from '~constant/salaryReport';
import { Nullable } from '~types/common';
import type { ISalaryInfo, IWikiChart } from '~types/company';
import { extractNumberFromString } from '~utils/common/number';

interface ISalaryType {
  rateType: 'TOTAL' | 'INDUSTRY';
  salaryRate: number;
}
export function selectSalaryType(salaryInfo: ISalaryInfo[]) {
  const pickedSalary = salaryInfo.filter((salary) => salary.category === 'ALL');

  return pickedSalary;
}

export const RankingGroup = {
  HIGHEST: 5,
  HIGH: 10,
  MIDDLE_HIGH: 25,
  MIDDLE: 50,
} as const;

export const RankingGroupText = {
  [RankingGroup.HIGHEST]: '최상위 수준',
  [RankingGroup.HIGH]: '상위 수준',
  [RankingGroup.MIDDLE_HIGH]: '중상위 수준',
  [RankingGroup.MIDDLE]: '중간 이상',
} as const;

export function getRankingGroup(rate: Nullable<number>) {
  if (!rate) {
    return null;
  }

  switch (true) {
    case rate <= 0.05:
      return RankingGroup.HIGHEST;
    case rate <= 0.1:
      return RankingGroup.HIGH;
    case rate <= 0.25:
      return RankingGroup.MIDDLE_HIGH;
    case rate <= 0.5:
      return RankingGroup.MIDDLE;
    default:
      return null;
  }
}

export function getSalaryRate(rate: number) {
  if (String(rate).indexOf('e') >= 0) {
    return 1;
  } else if (rate * 100 < 100) {
    /** 1% 이하 일때 올림 1% 이상은 반올림 */
    const calcRate = Math.round(rate * 100);

    return calcRate === 0 ? 1 : calcRate;
  } else {
    return 100;
  }
}
export const getSalaryType = (salaryInfo: ISalaryInfo): ISalaryType => {
  return {
    salaryRate: salaryInfo.rateType === 'TOTAL' ? salaryInfo.totalRate : salaryInfo.industryRate,
    rateType: salaryInfo.rateType,
  };
};

export function getCompanyhistory(
  foundedYear: number,
  closedAt: string | Date | null | undefined,
): [number, number | undefined] {
  const closedDate = closedAt && new Date(closedAt);
  const to = closedDate ? closedDate.getFullYear() : undefined;

  return [foundedYear, to];
}

export function getYearRangeString(from: number, to: number | undefined) {
  if (from && to) return `${from}-${to}`;
  if (from && !to) return `${from}`;

  return '';
}

export function isSalaryWikiEmpty(data: IWikiChart) {
  const dataEmptyCheckArray: boolean[] = [];
  data.forEach((wiki) => {
    dataEmptyCheckArray.push(wiki.isDataEmpty);
  });

  return dataEmptyCheckArray.filter((boolean) => boolean).length === 4;
}

/**
 * 커리어 년차(number)에 따라 적절한 메세지로 반환
 * @param career
 * @returns
 */
export function getCareerToString(career: number) {
  return careerOptions[career - 1];
}

/**
 * 문자열에 따라 년차정보(number)로 반환
 * @param career
 * @returns
 */
export function getStringToCareer(careerStr: string) {
  if (careerStr === careerOptions[0]) {
    return 1;
  } else if (careerStr === careerOptions[10]) {
    return 11;
  } else {
    return extractNumberFromString(careerStr);
  }
}
